import type { DialogId } from './type.tsx';

const QUICK_ADD_ITEMS: DialogId = 'quick-add-items';
const QUICK_ADD_ITEMS_COMMAND_PALETTE: DialogId = 'quick-add-items-command-palette';
const ISSUE_VIEW_BASE_ATTACHMENT: DialogId = 'issue-view-base-attachment';
const ISSUE_VIEW_BASE_ATTACHMENT_DROPZONE: DialogId = 'issue-view-base-attachment-dropzone';
const ISSUE_VIEW_ISSUE_DETAILS_DROPZONE: DialogId = 'issue-view-issue-details-dropzone';
const ISSUE_CREATE_ATTACHMENTS_FIELD: DialogId = 'issue-create-attachments-field';
const STORAGE_LIMITS_EDITOR_BANNER: DialogId = 'storage-limits-editor-banner';

export const STORAGE_HARD_LIMITS_MODAL_IDS = {
	QUICK_ADD_ITEMS,
	QUICK_ADD_ITEMS_COMMAND_PALETTE,
	ISSUE_VIEW_BASE_ATTACHMENT,
	ISSUE_VIEW_BASE_ATTACHMENT_DROPZONE,
	ISSUE_VIEW_ISSUE_DETAILS_DROPZONE,
	ISSUE_CREATE_ATTACHMENTS_FIELD,
	STORAGE_LIMITS_EDITOR_BANNER,
};
